exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".field-log{border-bottom:1px solid #d6d6d6;margin-bottom:1rem}.field-log:last-child{border-bottom:none}.field-log-attachment-icon{color:#607d8b}", "", {"version":3,"sources":["/./src/app/components/fieldLogListModal/src/app/components/fieldLogListModal/fieldloglistmodal.scss"],"names":[],"mappings":"AAAA,WACE,gCAAgC,AAChC,kBAAmB,CAIpB,AAND,sBAII,kBAAmB,CACpB,AAGH,2BACE,aAAc,CACf","file":"fieldloglistmodal.scss","sourcesContent":[".field-log {\n  border-bottom: 1px solid #d6d6d6;\n  margin-bottom: 1rem;\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.field-log-attachment-icon {\n  color: #607d8b;\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/fieldLogListModal/fieldloglistmodal.scss
// module id = 924
// module chunks = 0